import {
  ClientEvent,
  EventService,
} from './../../../shared/services/events.service';
import { Component, OnInit, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { OneColumnComponent } from '../../../shared/layout/one-column/one-column.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { EventCardComponent } from './event-card/event-card.component';

@Component({
  selector: 'app-events-home',
  standalone: true,
  imports: [
    CommonModule,
    OneColumnComponent,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    MatCardModule,
    NgOptimizedImage,
    EventCardComponent,
  ],

  template: `
    <section class="pb-3">
      <div class="full-flex accent pt-4 pb-0 mb-1 ai-c">
        <h3 class="mat-headline-3  m-0 p-0 flex-1">Events</h3>
        <a
          routerLink="/events"
          mat-stroked-button
          color="accent"
          class="bg-white border-radius-0"
        >
          <span class="full-flex ai-c">
            More&nbsp;<span class="desktop-only">Events</span
            ><mat-icon>chevron_right</mat-icon>
          </span>
        </a>
      </div>
      <div class="events-grid">
        @for (event of events(); track $index) {
        <app-event-card [event]="event"></app-event-card>
        }
      </div>
    </section>
  `,
  styles: [
    `
      .accent {
        color: white;
      }
      .bg-white {
        background-color: white;
      }

      .color-white {
        color: white;
      }

      .events-grid {
        display: grid;
        grid-template-columns: repeat(
          3,
          1fr
        ); /* Three columns of equal width */
        grid-gap: 16px; /* Adjust gap as needed */
        padding-top: 16px; /* Adjust padding as needed */
        padding-bottom: 16px; /* Adjust padding as needed */
      }

      @media (max-width: 768px) {
        .events-grid {
          grid-template-columns: 1fr; /* Single column for very small screens */
        }
      }
    `,
  ],
})
export class EventsHomeComponent implements OnInit {
  events = signal<ClientEvent[]>([]);
  constructor(private eventService: EventService) {}

  ngOnInit() {
    this.getEvents();
  }

  getEvents() {
    if (this.eventService.isBrowserOnly) {
      // Get the current date and format it as 'YYYY-MM-DD'
      const currentDate = new Date().toISOString().split('T')[0];

      this.eventService
        .getEvents(1, 3, currentDate, 'start', 'asc', true)
        .subscribe((response) => {
          if (response.data && response.data.events) {
            this.events.set(response.data.events);
          }
        });
    }
  }

  handleLinkClick(event: any) {
    console.log('Link clicked', event);
  }

  onError(event: any) {
    console.log('Error', event);
  }
}
